import { z } from "zod";

import { packagingComponentBaseSavedSchema } from "./packaging-component-base-saved";

export const packagingComponentLabelSavedSchema = packagingComponentBaseSavedSchema.extend({
	value: z.string().nullish(), // TODO nullable
	verificationCode: z.string().nullable().optional(),
});

export type PackagingComponentLabelSaved = z.infer<typeof packagingComponentLabelSavedSchema>;
